import classNames from 'classnames';

import { Link } from 'components/common/Link';

import styles from './Breadcrumbs.module.scss';
import { BreadcrumbsSeo } from './BreadcrumbsSeo';
import { BreadcrumbItem } from './types';

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  currentPageName?: string;
  className?: string;
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className, currentPageName }) => (
  <>
    {currentPageName && <BreadcrumbsSeo items={items} currentPageName={currentPageName} />}
    <nav aria-label='breadcrumb'>
      <ol className={classNames('breadcrumb', styles.breadcrumbs, className)}>
        {items.map(item =>
          item.href ? (
            <Link
              key={item.href}
              href={item.href}
              prefetch={!!item.prefetch}
              role='button'
              className={classNames(
                'breadcrumb-item text-truncate text-decoration-underline text-uppercase',
                { active: item.isActive },
                styles.breadcrumb
              )}
              target={item.target}
            >
              {item.label}
            </Link>
          ) : (
            <div
              key={item.label}
              className={classNames(
                'breadcrumb-item text-truncate text-uppercase',
                { active: item.isActive },
                styles.breadcrumb
              )}
            >
              {item.label}
            </div>
          )
        )}
        {items.length > 1 && <li className='breadcrumb-item' />}
      </ol>
    </nav>
  </>
);
